import React from "react";
import { Row, Col, Typography } from "antd";
import { Link } from "react-router-dom";
import vismaLogo from "assets/images/companyLogos/visma-logo.png";
import vismaLogoWhite from "assets/images/companyLogos/visma-logo-white.png";
import pwcLogo from "assets/images/companyLogos/PwC_logo_light_mode.png";
import pwcLogoWhite from "assets/images/companyLogos/PwC_logo_dark_mode.png";

const { Title, Text } = Typography;

const PartnersSection: React.FC = () => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ marginTop: "10em", marginBottom: "5%", paddingLeft: "2em", paddingRight: "2em" }}
    >
      {/* Title and Text */}
      <Col span={24} style={{ textAlign: "center", marginBottom: "2em" }}>
        <Row justify="center">
          <Col xs={24} sm={16} md={12} lg={14}>
            <Title level={1}>I samarbeid med</Title>
            <Text type="secondary" style={{ fontSize: "18px" }}>
              Gjennom flere år har Bindeleddet samarbeidet tett med Visma og PwC. Trykk på logoene for å lese mer om
              våre trofaste samarbeidspartnere.
            </Text>
          </Col>
        </Row>
      </Col>

      {/* Logos */}
      <Row justify="center" align="middle" gutter={[16, 24]} style={{ width: "100%" }}>
        <Col
          xs={24}
          sm={12}
          md={8}
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link to="/about-us/partners/">
            <img
              src={document.body.getAttribute("data-theme") === "dark" ? vismaLogoWhite : vismaLogo}
              alt="Visma logo"
              style={{
                maxWidth: "200px",
                maxHeight: "100px",
                objectFit: "contain",
                transition: "transform 0.3s ease", // Smooth scaling transition
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "scale(1.1)"; // Scale up
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "scale(1)"; // Reset scale
              }}
            />
          </Link>
        </Col>
        <Col
          xs={24}
          sm={12}
          md={8}
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link to="/about-us/partners/">
            <img
              src={document.body.getAttribute("data-theme") === "dark" ? pwcLogoWhite : pwcLogo}
              alt="PwC logo"
              style={{
                maxWidth: "200px",
                maxHeight: "100px",
                objectFit: "contain",
                transition: "transform 0.3s ease", // Smooth scaling transition
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "scale(1.1)"; // Scale up
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "scale(1)"; // Reset scale
              }}
            />
          </Link>
        </Col>
      </Row>
    </Row>
  );
};

export default PartnersSection;
